<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2>Site Colors</h2>
          </header>
        </div>
        <div class="w3-right-align w3-margin-top w3-margin-bottom">
          <button class='w3-button w3-small' :class="saving || saved ? 'w3-dark-teal' : 'w3-teal'" :disabled="saving || saved" @click="saveContent()"><span v-if="!saved">Save Changes</span><span v-if="saved">Changes Saved</span></button>
        </div>
      </div>

      <div class="outline w3-padding" style="background:#f8f8f8;">
        <div class="input-row-2">
          <div>
            <h4 class="w3-margin-bottom w3-margin-top">Primary Colors</h4>
            <label class="w3-label">Primary Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.primary.main" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.primary.main, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Primary Text Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.primary.text" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.primary.text, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Primary Border Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.primary.border" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.primary.border, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Primary Hover Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.primary.hover" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.primary.hover, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Primary Active Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.primary.active" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.primary.active, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Primary Active Border Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.primary.activeBorder" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.primary.activeBorder, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
          </div>
          <div>
            <h4 class="w3-margin-bottom w3-margin-top">Secondary Colors</h4>
            <label class="w3-label">Secondary Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.secondary.main" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.secondary.main, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Secondary Text Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.secondary.text" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.secondary.text, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Secondary Border Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.secondary.border" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.secondary.border, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Secondary Hover Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.secondary.hover" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.secondary.hover, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Secondary Active Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.secondary.active" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.secondary.active, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Secondary Active Border Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.secondary.activeBorder" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.secondary.activeBorder, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
          </div>
          <!-- <div>
            <h4 class="w3-margin-bottom w3-margin-top">Tertiary Colors</h4>
            <label class="w3-label">Tertiary Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.tertiary.main" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.tertiary.main, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Tertiary Text Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.tertiary.text" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.tertiary.text, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Tertiary Border Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.tertiary.border" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.tertiary.border, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Tertiary Hover Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.tertiary.hover" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.tertiary.hover, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Tertiary Active Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.tertiary.active" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.tertiary.active, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Tertiary Active Border Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.tertiary.activeBorder" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.tertiary.activeBorder, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
          </div>
          <div>
            <h4 class="w3-margin-bottom w3-margin-top">Quaternary Colors</h4>
            <label class="w3-label">Quaternary Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.quaternary.main" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.quaternary.main, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Quaternary Text Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.quaternary.text" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.quaternary.text, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Quaternary Border Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.quaternary.border" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.quaternary.border, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Quaternary Hover Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.quaternary.hover" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.quaternary.hover, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Quaternary Active Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.quaternary.active" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.quaternary.active, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Quaternary Active Border Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.quaternary.activeBorder" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.quaternary.activeBorder, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
          </div> -->
        </div>
        <div class="input-row-2">
          <div>
            <h4 class="w3-margin-bottom w3-margin-top">Dark Colors</h4>
            <label class="w3-label">Dark Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.dark.main" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.dark.main, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Dark Text Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.dark.text" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.dark.text, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Dark Border Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.dark.border" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.dark.border, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Dark Hover Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.dark.hover" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.dark.hover, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Dark Active Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.dark.active" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.dark.active, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Dark Active Border Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.dark.activeBorder" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.dark.activeBorder, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
          </div>
          <div>
            <h4 class="w3-margin-bottom w3-margin-top">Light Colors</h4>
            <label class="w3-label">Light Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.light.main" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.light.main, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Light Text Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.light.text" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.light.text, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Light Border Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.light.border" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.light.border, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Light Hover Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.light.hover" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.light.hover, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Light Active Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.light.active" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.light.active, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
            <label class="w3-label">Light Active Border Color</label>
            <div style="display:grid; grid-template-columns: 8fr 1fr;">
              <input v-model="state.siteData.colors.light.activeBorder" placeholder="#212121" class="w3-input w3-border" />
              <div class="w3-padding outline" :style="{'background': state.siteData.colors.light.activeBorder, 'margin':'1px 1px 0.5px 0'}"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="w3-right-align w3-margin-top w3-margin-bottom">
        <button class='w3-button' :class="saving || saved ? 'w3-dark-teal' : 'w3-teal'" :disabled="saving || saved" @click="saveContent()"><span v-if="!saved">Save Changes</span><span v-if="saved">Changes Saved</span></button>
      </div>
    </div>
  </div>
</template>

<script>
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsSettings',
  data() {
    return {
      state: dataStore.state,
      view: 'global',
      saving: false,
      saved: false
    }
  },
  methods: {
    saveContent() {
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 2000)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsColors.vue